import React, { useEffect } from 'react'
import { css } from 'src/ui/style/css'
import { useTheme } from 'src/ui/style/useTheme'
import { icon } from '../icon/icons'
import { Theme } from '../style/Theme'
import { Icon } from '../icon/Icon'
import { isMobileScreen } from '../style/ScreenSize'
import { useIsQrCodeAccessPage } from '../../hooks/useIsQrCodeAccessPage'

interface ChatbotButtonProps {
    onClick: () => void
    label: string
}

const ChatbotButton: React.FC<ChatbotButtonProps> = ({ onClick, label }) => {
    const isQrCodeAccessPage = useIsQrCodeAccessPage()
    const buttonRef = React.useRef<HTMLButtonElement>(null)
    const th = useTheme()
    const isMobile = isMobileScreen()

    if (isQrCodeAccessPage) {
        return null
    }

    useEffect(() => {
        const returnToOrderButton = document.getElementById(
            'return-to-order-button'
        )
        const currentButton = buttonRef.current

        if (returnToOrderButton && currentButton) {
            currentButton.style.bottom =
                returnToOrderButton.offsetHeight + 20 + 'px'
        }
    }, [])

    return (
        <button
            ref={buttonRef}
            onClick={onClick}
            css={css`
                width: ${isMobile ? '50px' : 'auto'};
                height: ${isMobile ? '50px' : 'auto'};
                justify-content: center;
                position: fixed;
                bottom: 20px;
                right: 20px;
                z-index: 999;
                background-color: ${th.colors.secondary};
                color: ${th.colors.white};
                border: none;
                border-radius: ${isMobile ? '50%' : th.borderRadius.secondary};
                padding: ${isMobile ? th.spacing.sm : '12px 20px'};
                font-weight: bold;
                cursor: pointer;
                display: flex;
                align-items: center;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                pointer-events: auto;
                transition: all 0.2s ease;

                &:hover {
                    background-color: ${th.colors.primary};
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
                }

                &:active {
                    transform: translateY(0);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
            `}
        >
            <Icon
                icon={icon.ChatBubble}
                css={(th: Theme) =>
                    css`
                        font-size: calc(${th.fontSize.sm} * 1.5);
                        cursor: pointer;
                    `
                }
            />
            {isMobile ? null : (
                <span
                    css={css`
                        padding-left: 8px;
                    `}
                >
                    {label}
                </span>
            )}
        </button>
    )
}

export default ChatbotButton
